import { InvoiceDirection } from "@/apps/tatar/invoiceApp/RAInterfaces";
import FormStruct from "@/components/Form/FormStruct/FormStruct";
import i18n from "@/i18n";
import { ModeOfPaymentWithUnit } from "@/redux/actions/struct/implemented/InvoiceStruct";
import { hasValue } from "@/utils/Helpers";
import ObjectIdService from "@/utils/ObjectIdUtils";
import RACService from "../../RACService";
import ModeOfPaymentFormFields from "./ModeOfPaymentFormFields";
// import './ModelOfPaymentCreationForm.scss';

interface ModelOfPaymentCreationFormProps {
  onClose: () => void;
  onSuccess?: () => void;
  direction: InvoiceDirection;
  unit?: string;
}
const ModeOfPaymentCreationForm = (props: ModelOfPaymentCreationFormProps) => {
  return (
    <FormStruct<ModeOfPaymentWithUnit>
      onSubmit={async (values) => {
        const { unit, ...data } = values;
        await RACService.createNewModeOfPayment(unit, props.direction, data);

        props.onSuccess?.();
        props.onClose();
      }}
      onAbort={props.onClose}
      initialValues={{
        identifier: null,
        kind: null,
        payments: [],
        displayName: null,
        unit: props.unit || null,
        id: ObjectIdService.new(),
        status: "active",
        editable: false,
      }}
      title={i18n.t(
        "rac:ModeOfPayment.createTitle",
        "Zahlungsmodalität erstellen"
      )}
      description={i18n.t(
        "rac:ModeOfPayment.createDescription",
        "Erstellen Sie eine neue Zahlungsmodalität, geben Sie an, um welche Art von Zahlung es sich handelt und für welchen Bereich diese Zahlungsmodalität gelten soll."
      )}
      render={(formApi) => (
        <ModeOfPaymentFormFields
          formApi={formApi.form}
          isCreationForm
          disableUnit={hasValue(props.unit)}
        />
      )}
    />
  );
};

export default ModeOfPaymentCreationForm;
